// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"0d5432e2","934":"dccb981d"}[chunkId] + ".css";
};